<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_817', [params.data[0].id])}}</div>
    <div slot="body">
      <a-descriptions :title="$t('scope.text_818')" bordered>
        <a-descriptions-item :label="$t('scope.text_439')">
          {{ params.data[0].title }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_819')" :span="2">
          {{ params.data[0].description }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_820')">
          <span v-if="params.data[0].currency === 'USD'">$</span><span v-else>￥</span>{{ params.data[0].amount | numerify('0,0.00') }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_449')">
          {{ params.data[0].currency }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_666')">
          {{ exchange_rate }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_448')" :span="3">
          <span v-if="currentCurrency === 'USD'">$</span><span v-else>￥</span>{{ pay_amount | numerify('0,0.00') }}
        </a-descriptions-item>
      </a-descriptions>
      <a-divider />
      <div class="title">{{$t('scope.text_277')}}</div>
      <div>
        <a-row>
          <a-col :span="4" class="voucherDesc">{{$t('scope.text_821', [ voucherCount ])}}</a-col>
          <a-col :span="10">
            <list-select
              :list-props="voucherProps"
              :formatter="formatter"
              :items.sync="voucherItem" />
          </a-col>
        </a-row>
      </div>
      <a-divider />
      <div class="title">{{$t('scope.text_577')}}</div>
      <div>
        {{$t('scope.text_822', [balance | numerify('0,0.00')])}}
        <span v-if="currentCurrency === 'USD'">{{$t('scope.text_469')}}</span>
        <span v-else>{{$t('scope.text_468')}}</span>{{$t('scope.text_823')}}<a-input-number class="ml-2 mr-2" v-model="usedBalance" :min="0" :max="balance" />
        <span v-if="currentCurrency === 'USD'">{{$t('scope.text_469')}}</span>
        <span v-else>{{$t('scope.text_468')}}</span>
      </div>
      <a-divider />
      <div>
        <a-row class="mb-2" v-if="usedVoucherAmount">
          <a-col :span="20" class="text-right">{{$t('scope.text_824')}}</a-col>
          <a-col :span="4" class="text-right">
            <span>-{{usedVoucherAmount | numerify('0,0.00')}}</span>
          </a-col>
        </a-row>
        <a-row class="mb-2" v-if="usedBalance && usedBalance > 0">
          <a-col :span="20" class="text-right">{{$t('scope.text_825')}}</a-col>
          <a-col :span="4" class="text-right">
            <span>-{{usedBalance | numerify('0,0.00')}}</span>
          </a-col>
        </a-row>
        <a-row class="mb-2">
          <a-col :span="20" class="text-right">{{$t('scope.text_826')}}</a-col>
          <a-col :span="4" class="text-right">
            <span>{{ subtotalMoney }}</span>
            <span v-if="currentCurrency === 'USD'">{{$t('scope.text_469')}}</span>
            <span v-else>{{$t('scope.text_468')}}</span>
          </a-col>
        </a-row>
      </div>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{$t('scope.text_450')}}</a-button>
      <a-button @click="cancelDialog">{{$t('scope.text_457')}}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import {
  getCopyWithContentTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import ListSelect from '@/sections/ListSelect'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'PayBillDialog',
  components: {
    ListSelect,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      numerify,
      loading: false,
      isUsedVoucher: true,
      usedVoucherAmount: 0,
      voucherCount: 0,
      usedBalance: 0,
      balance: 0,
      voucherItem: [],
      pay_amount: 0,
      exchange_rate: 1,
      currentCurrency: 'CNY',
      voucherProps: {
        list: this.$list.createList(this, {
          resource: 'billing_coupons',
          getParams: this.getParam,
        }),
        columns: [
          getCopyWithContentTableColumn({
            field: 'id',
            title: this.$t('scope.text_451'),
          }),
          {
            field: 'type',
            title: this.$t('scope.text_827'),
            minWidth: 70,
          },
          {
            field: 'amount',
            title: this.$t('scope.text_647'),
            minWidth: 100,
          },
          {
            field: 'currency',
            title: this.$t('scope.text_442'),
            minWidth: 70,
          },
          {
            title: this.$t('scope.text_512'),
            field: 'notes',
            minWidth: 120,
          },
          getTimeTableColumn({ title: this.$t('scope.text_828'), field: 'valid_since' }),
          getTimeTableColumn({ title: this.$t('scope.text_829'), field: 'valid_until' }),
          {
            title: this.$t('scope.text_426'),
            field: 'status',
            minWidth: 70,
          },
        ],
      },
    }
  },
  computed: {
    subtotalMoney () {
      const value = this.pay_amount - (this.usedBalance > 0 ? this.usedBalance : 0) - this.usedVoucherAmount
      if (numerify(value, '0,0.00') < 0) return numerify(0, '0,0.00')
      return numerify(value, '0,0.00')
    },
    subtotalNumber () {
      const value = this.pay_amount - (this.usedBalance > 0 ? this.usedBalance : 0) - this.usedVoucherAmount
      if (value < 0) return 0
      return value
    },
  },
  watch: {
    isUsedVoucher (newVal, oldVal) {
      this.usedVoucherAmount = 0
    },
    voucherItem (newVal, oldVal) {
      if (newVal.length > 0) {
        this.usedVoucherAmount = newVal.reduce((pre, item) => {
          return pre + item.amount
        }, 0)
      } else {
        this.usedVoucherAmount = 0
      }
    },
  },
  created () {
    this.accountM = new this.$Manager('billing_accounts')
    this.billM = new this.$Manager('billpays')
    this.fetchPayAmount()
    this.fetchBalance()
    // 监听充值后充值状态
    this.$bus.$on('billAccountPaymentStatus', async (status) => {
      if (status === 'complete') {
        this.loading = true
        try {
          await this.doPayBill()
          this.loading = false
          this.cancelDialog()
          this.$message.success(this.$t('scope.text_830'))
          this.params.refresh()
        } catch (error) {
          this.loading = false
          throw error
        }
      } else {
        this.cancelDialog()
        this.params.refresh()
      }
    })
  },
  methods: {
    formatter (val) {
      return this.$t('scope.text_831', [val.amount])
    },
    async fetchBalance () {
      const { data: { data = [] } } = await this.accountM.list()
      const { data: res } = await this.accountM.getSpecific({
        id: data[0].id,
        spec: 'balance',
      })
      this.balance = res.sub_accounts[this.currentCurrency].balance || 0
      this.voucherCount = res.coupon_count
    },
    async fetchPayAmount () {
      const { data } = await this.billM.getSpecific({
        id: this.params.data[0].id,
        spec: 'pay',
      })
      this.pay_amount = data.pay_amount
      this.exchange_rate = data.exchange_rate
      this.currentCurrency = data.currency
    },
    listDataChange (val) {
      this.usedVoucherAmount = val.amount
    },
    getParam () {
      return {
        currency: this.currentCurrency,
      }
    },
    doPayBill () {
      const data = {
        currency: this.currentCurrency,
      }
      if (this.voucherItem.length > 0) {
        data.coupons = this.voucherItem.map(item => {
          return item.id
        })
      }
      return this.billM.performAction({
        id: this.params.data[0].id,
        action: 'pay',
        data,
      })
    },
    async handleConfirm () {
      // 小计为零直接支付账单，否则走充值余额后再支付账单
      if (this.subtotalNumber === 0) {
        this.loading = true
        try {
          await this.doPayBill()
          this.loading = false
          this.cancelDialog()
          this.$message.success(this.$t('scope.text_830'))
          this.params.refresh()
        } catch (error) {
          this.loading = false
          throw error
        }
      } else {
        if (this.currentCurrency === 'CNY') {
          this.createDialog('ChoosePaymentMethodDialog', {
            amount: this.subtotalNumber,
          })
        } else {
          this.$message.warning(this.$t('common_481'))
        }
      }
    },
  },
}
</script>
<style lang="less" scoped>
  .title {
    margin-top: 20px;
    margin-bottom: 20px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 16px;
    line-height: 1.5;
  }
  .voucherDesc {
    height: 30px;
    line-height: 30px;
  }
</style>
